import axios from './axios';

const base = APP_CONFIG.api.url;

const contentTypes = {
  form: 'multipart/form-data',
  json: 'application/json',
};

const responseTypes = {
  json: 'json',
  stream: 'blob',
};

const request = (path, method, data, cType, rType, params = null, headers = {}) => {
  const contentType = cType || contentTypes.json;
  const responseType = rType || responseTypes.json;
  return axios({
    method,
    data,
    url: `${base}/${path}`,
    headers: {
      'Content-Type': `${contentType}`,
      ...headers,
    },
    responseType,
    withCredentials: true,
    params: params,
  })
    .then((result) => {
      return result.data;
    })
    .catch((error) => {
      if (error.response) {
        throw (error.response.data);
      } else {
        throw (error.message);
      }
    });
};

const requestExternal = (url, method) => {
  return axios({
    url,
    method,
    responseType: responseTypes.stream,
    withCredentials: true,
  })
  .then((result) => {
    return result.data;
  })
  .catch((error) => {
    if (error.response) {
      throw (error.response.data);
    } else {
      throw (error.message);
    }
  });
};

const requestExternalNoCache = (url, method) => {
  return axios({
    url,
    method,
    responseType: responseTypes.stream,
    withCredentials: false,
    headers: {'Cache-Control': 'no-cache'},
  })
  .then((result) => {
    return result.data;
  })
  .catch((error) => {
    if (error.response) {
      throw (error.response.data);
    } else {
      throw (error.message);
    }
  });
};

export default {
  contentTypes,
  responseTypes,
  request,
  requestExternal,
  requestExternalNoCache,
};
